import { registerPlugin } from '@capacitor/core';

export const Whisper = registerPlugin('Whisper'); 